import { Tooltip } from "antd";
import { useCallback, useEffect, useRef } from "react";
import { setTrackingOp } from "../../../contexts/TrackingOpContext";
import { stepNameV2 } from "../../../util/varibles/global";
import { IActivityLog } from "../../../util/varibles/interface";
import styles from './style.module.scss';

export default function Steps({ activity_log, step }: { activity_log: IActivityLog[], step: number }) {
    const rootRef = useRef<HTMLDivElement>(null);
    const set = setTrackingOp();

    useEffect(() => {
        const el = rootRef.current;
        if (!el) return;

        const onWheel = (e: WheelEvent) => {
            e.preventDefault();

            const item = el.children[0] as HTMLElement;
            if (!item) return;

            const step = item.offsetWidth + 16; // width + gap

            if (e.deltaY > 0) {
                el.scrollBy({ left: step, behavior: "smooth" });
            } else {
                el.scrollBy({ left: -step, behavior: "smooth" });
            }
        };

        el.addEventListener("wheel", onWheel, { passive: false });
        return () => el.removeEventListener("wheel", onWheel);
    }, []);

    const onChangeStep = useCallback((index: number) => {
        set({ step: index });
    }, [set]);

    return <div className={styles.steps} ref={rootRef} style={{ '--cols': activity_log.length } as any}>
        {activity_log.map((item, index) => {
            const name = stepNameV2(item.key)
            return <div key={index} className={styles.step} data-active={index === step} onClick={() => onChangeStep(index)}>
                <Tooltip title={name} >
                    <span className="truncate">{name}</span>
                </Tooltip>
            </div>
        })}
    </div>
}